import { api } from './api-client'
import { generateBasicAuthToken } from './auth'
import type { Environment } from './config'

export interface PreferencesResponse {
  identity: {
    email: string
    accountNumber: string
  }
  language: string
  channels: {
    email: {
      newsletter: boolean
      curatedForYou: boolean
    }
  }
}

export interface UpdatePreferencesPayload {
  identity: {
    email: string
    accountNumber: string
  }
  code: string
  language: string
  channels: {
    email: {
      newsletter: boolean
      curatedForYou: boolean
    }
  }
  executedBy: string
  deliveryId?: string
}

export const fetchPreferences = async (
  identifier: string,
  authCode: string,
  env?: Environment,
  token?: string,
  isAccountNumber = false,
): Promise<PreferencesResponse> => {
  // Use provided token (Bearer) or generate Basic auth from identifier/code
  const authToken = token || generateBasicAuthToken(identifier, authCode)
  const authType = token ? 'Bearer' : 'Basic'

  // Use accountNumber or email as query parameter
  const queryParam = isAccountNumber
    ? `AccountNumber=${encodeURIComponent(identifier)}`
    : `Email=${encodeURIComponent(identifier)}`

  return api<PreferencesResponse>(
    `/public/customerpreferenceapi/v1/Preferences?${queryParam}`,
    { env, authToken, authType },
  )
}

export const updatePreferences = async (
  payload: UpdatePreferencesPayload,
  env?: Environment,
  token?: string,
): Promise<PreferencesResponse> => {
  // Use provided token (Bearer) or generate Basic auth from payload identity.email/code
  const authToken =
    token || generateBasicAuthToken(payload.identity.email, payload.code)
  const authType = token ? 'Bearer' : 'Basic'

  return api<PreferencesResponse>(
    '/public/customerpreferenceapi/v1/Preferences',
    {
      method: 'PATCH',
      body: payload,
      env,
      authToken,
      authType,
    },
  )
}
